import { render } from "./AmWindowErrorEdit.vue?vue&type=template&id=64d757c0"
import script from "./AmWindowErrorEdit.vue?vue&type=script&lang=js"
export * from "./AmWindowErrorEdit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__